@if (node2 | async; as item) {
  <div class="flucelvax-firstvideo">
    @if (item.uid=='SeqirusFlucelvaxFirstComponent') {
      <div>
        <!--For desktop-->
        @if (item?.media?.desktop?.url) {
          <section class="landingpage_videoContainer d-none d-lg-block banner_bg" [ngStyle]="{'background': 'linear-gradient(90deg, rgba(0,0,0,0.95) 0%, rgba(0,0,0,0.15) 40%),' + 'linear-gradient(0deg, rgba(0,0,0,0.95) 0%, rgba(0,0,0,0.15) 40%),' +'url(' + baseUrl + item.media.desktop.url + ') no-repeat center top','background-size': 'auto, auto, cover','background-repeat': 'no-repeat, no-repeat, no-repeat'}">
            <div class="row">
              <div class="col-md-8">
                <div class="title_banner" [innerHTML]="item.headline"></div>
                <div class="title_Subbanner" [innerHTML]="item.bottomcontent"></div>
                <div class="subtitle_banner" [innerHTML]="item.largeparagraphcontent"></div>
                <div class="banner_button"><a [routerLink]="item.urlLink" target="_self"
                title="{{item.h2content}}">{{item.h2content}}</a></div>
                <div class="disclaimer" [innerHTML]="item.content"></div>
              </div>
              <div class="col-md-4">
                @if (item?.mediaPicture) {
                  <div class="transparent_label">
                    <cx-media [alt]="item?.altText" [container]="item?.mediaPicture" style="width:80%" class="transparante_Label_Img"></cx-media>
                    <div class="section_Divide"></div>
                    <div class="caption_group">
                      <div class="caption_1" [innerHTML]="item.h3content"></div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </section>
        }
        <!--For mobile-->
        <section class="landingpage_videoContainer d-lg-none d-block">
          @if (item?.mediaPicture) {
            <div class="flucelvax_logo_mob">
              <cx-media [alt]="item?.altText" [container]="item?.mediaPicture" style="width:200px"></cx-media>
            </div>
          }
          <div class="caption_group">
            <div class="caption_1 mobile_Caption" [innerHTML]="item.h3content"></div>
          </div>
          @if (item?.media?.mobile?.url) {
            <div class="mobile_banner"
              [ngStyle]="{'background': 'url(' + baseUrl + item.media.mobile.url +  ') no-repeat center top var(--darkblack)','background-size': 'cover'}">
              <div class="title_banner" [innerHTML]="item.headline"></div>
              <div class="mobile_block top_Mobile_Block">
                <div class="title_Subbanner" [innerHTML]="item.bottomcontent"></div>
                <div class="subtitle_banner" [innerHTML]="item.largeparagraphcontent"></div>
              </div>
            </div>
          }
          <div class="mobile_block">
            <div class="disclaimer" [innerHTML]="item.content"></div>
          </div>
        </section>
      </div>
    }
  </div>
}

<!-- <div class="fluad-firstvideo" *ngIf ="node2 | async as item">
<section class="landingpage_videoContainer d-none d-md-block" *ngIf="item.uid=='SeqirusFluadFirstComponent'">
  <video muted="" autoplay="" playsinline=""  title="shield of adjuvant advantage" class="flucelvaxAdjAdvVideo" type="video/mp4">
    <source [src]="getVideo(item?.mediaVideo)" type="video/mp4">
  </video>
</section>
<section class="landingpage_videoContainer d-md-none d-block" *ngIf="item.uid=='SeqirusFluadFirstMobComponent'">
  <video muted="" autoplay="" playsinline="" title="shield of adjuvant advantage" class="flucelvaxAdjAdvVideo" type="video/mp4">
    <source [src]="getVideo(item?.mediaVideo)" type="video/mp4">
  </video>
</section>
</div> -->
